let _this;
function hideFileTransfer(e){
  if($(e.target).parents('.file-transfer-page').length <= 0 && $(e.target).parents('#file-transfer-failure').length <= 0){
    _this.isShow = false;
  }
  _this.$root.navOperateType = 0;
}
import scrollLoadList from '../commonComponents/scrollLoadList.vue'
export default {
  name: "asynchronousUpload",
  components:{scrollLoadList},
  data(){
    return{
      isShow:false,
      asynchronousList:[],
      failureDetailsModal:false,
      tabIndex:0,
      failureDetailsInfo:{},
      flag:false,
      isLoading:false,
      messageCount:30,
      lastScrollTop:'',
      taskTypeList:{
        //导入文件的后台任务
        '0':{value:0, label:'Import ' + this.ApiService.staffName},
        '1':{value:1, label:'Import Visitor'},
        '2':{value:2, label:'Import Vendor'},
        '3':{value:3, label:'Import Tenant'},
        '4':{value:4, label:'Import Access Code'},
        '5':{value:5, label:'Import Device'},
        '6':{value:6, label:'Import Card'},
        '8':{value:8, label:'Import Access Zone'},
        '9':{value:9, label:'Import Account'},
        '10':{value:10, label:'Import Vehicle'},
        '11':{value:11, label:'Import WatchList'},
        '12':{value:12, label:'Import Asset'},
        '13':{value:13, label:'Import Asset Zone'},
        '14':{value:14, label:'Import Module'},
        //用户相关的后台任务
        '1001':{value:1001, label:'Add Access Code To User In Batch'},
        '1002':{value:1002, label:'Remove Access Code From User In Batch'},
        '1003':{value:1003, label:'Add Tag To User In Batch'},
        '1004':{value:1004, label:'Remove Tag From User In Batch'},
        '1005':{value:1005, label:'Add DCS Access Zone To User In Batch'},
        '1006':{value:1006, label:'Remove DCS Access Zone From User In Batch'},
        //车辆相关的后台任务
        '1007':{value:1007, label:'Add Access Code To Vehicle In Batch'},
        '1008':{value:1008, label:'Delete Vehicle Access Code In Batch'},
        '1009':{value:1009, label:'Add Tag To Vehicle In Batch'},
        '1010':{value:1010, label:'Remove Tag To Vehicle In Batch'},
        //AC相关的后台任务
        '1011':{value:1011, label:'Add Access Zone To Access Code'},
        '1012':{value:1012, label:'Remove Access Zone From Access Code'},
        //卡相关的后台任务
        '1013':{value:1013, label:'Add Tag To Card In Batch'},
        '1014':{value:1014, label:'Remove Tag From Card In Batch'},
        //组织相关的后台任务
        '1015':{value:1015, label:'Add Access Code To Department In Batch'},
        '1016':{value:1016, label:'Remove Access Code To Department In Batch'},
        '1017':{value:1017, label:'Add DCS Access Zone To Department In Batch'},
        '1018':{value:1018, label:'Remove DCS Access Zone To Department In Batch'},
        '1019':{value:1019, label:'Add Access Code To Tenant Company In Batch'},
        '1020':{value:1020, label:'Remove Access Code From Tenant Company In Batch'},
        '1021':{value:1021, label:'Add DCS Access Zone To Tenant Company In Batch'},
        '1022':{value:1022, label:'Remove DCS Access Zone From Tenant Company In Batch'},
        '1030':{value:1011, label:'Add Module To User'},
        '1031':{value:1012, label:'Remove Module From User'},
        '1032':{value:1012, label:'Add Module To ' + this.ApiService.departmentText},
        '1033':{value:1012, label:'Remove Module From ' + this.ApiService.departmentText},
      },
      searchInfo:{
        enabledPaging:true,
        operationType:null,
        page:1,
        perPage:20,
        pageCount:0,
      },
      refreshTimer:'',
      triangleRight:0,
      displayList:[],
      detailsTitle:[],
      detailsData:[],
      isTableLoading:false,
      operatTypes:[0,1,2,3],
      hasSecurity:false,
    }
  },
  mounted(){
    _this = this;
    this.taskSort();
    $(document).bind('click', hideFileTransfer);
  },
  beforeDestroy(){
    $(document).unbind('click', hideFileTransfer);
  },
  methods:{
    getTotal:function (callback) {
      if(_this.$root.adminInfo.permissionCodes.indexOf('M_BackendTask') == -1){    
        return 
      }
      if( ! _this.ApiService.accessToken  ){
        return;
      }
      _this.$ajax.get('BackgroundUpload/GetTotalProcessing',{headers:{noLoading:true}}).then(res =>{
        if(res.data.success){
          let count = res.data.data;
          callFun(5000,count);
        }else{
          callFun(5000,0);
        }
      }).catch(err =>{
        callFun(_this.$root.reconnectTime,0);
      });

      function callFun(time,num) {
        if(callback && typeof callback === "function"){
          callback(num);
        }
        _this.refreshTimer = setTimeout(() => {
          _this.getTotal(callback);
        },time);
      }
    },
    // 后台任务名称排序
    taskSort(){
      let array = Object.values(_this.taskTypeList);
      _this.displayList = array.sort((x,y)=>{
        return x['label'].localeCompare(y['label']);
      });
    },
    open:function(){
      _this.isShow = true;
      _this.searchInfo.operationType = null;
      _this.showAsynchronousInfo(false);
    },
    showAsynchronousInfo:function (flag) {
      let data = JSON.parse(JSON.stringify(_this.searchInfo));
      if(data.operationType === 'All'){
        data.operationType = null;
      }else{
        data.operationType = parseInt(data.operationType);
      }
      //判断是不是刷新
      if(flag){
        data.page = 1;
      }
      this.$ajax.post('BackgroundUpload/Paging', data, {headers:{noLoading:true}, codes: ['M_AsynchronousUpload'] }).then(function (res) {
        if (res.data.success) {
          let result = res.data.data;
          if(flag && flag !== 1){
            //去重
            let set1 = new Set(result.items);
            let set2 = new Set(_this.asynchronousList);
            _this.asynchronousList = _this.shareApi.dataDeduplication(Array.from(new Set([...set1,...set2])));
          }else{
            console.log(_this.searchInfo.page + '//////////////////');
            _this.isLoading = false;
            _this.searchInfo.pageCount = result.pageCount;
            if(data.page === 1){
              _this.asynchronousList = result.items;
              _this.$refs.scrollList.resetRender();
            }else{
              _this.asynchronousList = _this.asynchronousList.concat(result.items);
            }
          }
          if(flag && _this.isShow){
            _this.refreshTimer = setTimeout(() => {
              _this.showAsynchronousInfo(flag);
            },5000);
          }
        }else {
          _this.asynchronousList = [];
          if(flag && _this.isShow){
            _this.refreshTimer = setTimeout(() => {
              _this.showAsynchronousInfo(flag);
            },5000);
          }
        }
      }).catch((error) => {
        if(flag && _this.isShow){
          _this.refreshTimer = setTimeout(() => {
            _this.showAsynchronousInfo(flag);
          },_this.$root.reconnectTime);
        }
      })
    },
    searchAsynchronousInfo:function(){
      _this.searchInfo.page = 1;
      _this.showAsynchronousInfo(false);
    },
    getTotal:function (callback) {
      clearTimeout(_this.refreshTimer);
      if( ! ( _this.ApiService.accessToken && _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf('M_ViewAsynchronousUpload') > -1 ) ){
        return;
      }
      _this.$ajax.get('BackgroundUpload/GetTotalProcessing',{headers:{noLoading:true}}).then(res =>{
        if(res.data.success){
          let count = res.data.data;
          callFun(5000,count);
        }else{
          callFun(5000,0);
        }
      }).catch(err =>{
        callFun(_this.$root.reconnectTime,0);
      });
      function callFun(time,num) {
        if(callback && typeof callback === "function"){
          callback(num);
        }
        _this.refreshTimer = setTimeout(() => {
          _this.getTotal(callback);
        },time);
      }
    },
    changeTabIndex:function(index){
      _this.tabIndex = index;
      _this.setDetailsTitle();
    },
    //查看失败详情
    failureDetdils:function(item){
      _this.tabIndex = 0;
      _this.failureDetailsModal = true;
      _this.isTableLoading = true;
      _this.hasSecurity = false;
      this.$ajax.get('BackgroundUpload/GetDetail?id='+ item.id).then(function (res) {
        if (res.data.success) {
          _this.failureDetailsInfo = res.data.data;
          if(_this.failureDetailsInfo.details.length){
            _this.failureDetailsInfo.details.forEach(it=>{
              if(it.extensions && it.extensions.hasSecurityTag){
                _this.hasSecurity = true;
              }
            })
          }
          _this.setDetailsTitle();
        }else {
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
        _this.isTableLoading = false;
      })
    },
    setDetailsTitle:function(){
      if(_this.tabIndex === 0){
        if(_this.failureDetailsInfo.operationType === 5){
          _this.detailsTitle = [
            {title: 'Sub Table Name', slot: 'sheet', minWidth:120},
            {title: 'Device Name', slot: 'name', minWidth:120},
            {title: 'Line', slot: 'line', width:120},
            {title: 'Success', slot: 'result', minWidth: 120}
          ]
        }else if(_this.operatTypes.indexOf(_this.failureDetailsInfo.operationType) > -1){
          _this.detailsTitle = [
            {title: 'User Name', slot: 'line', minWidth:450},
            {title: 'Success', slot: 'result', minWidth: 450}
          ]
        } else{
          _this.detailsTitle = [
            {title: 'Line', slot: 'line', minWidth:450},
            {title: 'Success', slot: 'result', minWidth: 450}
          ]
        }
      }else if(_this.tabIndex === 1){
        if(_this.failureDetailsInfo.operationType === 5){
          _this.detailsTitle = [
            {title: 'Sub Table Name', key: 'sheet', minWidth:120},
            {title: 'Device Name', slot: 'name', minWidth:120},
            {title: 'Line', slot: 'line', width:120},
            {title: 'Failure Reason', slot: 'result', minWidth: 120}
          ]
        }else{
          _this.detailsTitle = [
            {title: 'Line', slot: 'line', width:120},
            {title: 'Failure Reason', slot: 'result', minWidth: 450}
          ]
        }
      }else if(_this.tabIndex === 2){
        if(_this.failureDetailsInfo.operationType === 5){
          _this.detailsTitle = [
            {title: 'Sub Table Name', key: 'sheet', minWidth:120},
            {title: 'Device Name', slot: 'name', minWidth:120},
            {title: 'Line', slot: 'line', width:120},
            {title: 'Failure Reason', slot: 'result', minWidth: 120}
          ]
        }else{
          _this.detailsTitle = [
            {title: 'Line', slot: 'line', width:120},
            {title: 'Warning Reason', slot: 'result', minWidth: 450}
          ]
        }
      }
      if(_this.failureDetailsInfo.details && _this.failureDetailsInfo.details.length > 0){
        _this.detailsData = _this.failureDetailsInfo.details.filter(item => _this.tabIndex === item.type)
      }else{
        _this.detailsData = [];
      }
    },
    //打开异步上传的具体信息
    openMoreFileTransferInfo:function(e){
      $(e.target).parents('.file-transfer-item-header').siblings('.file-transfer-item-center').slideToggle();
      $(e.target).toggleClass('open')
    },
    //删除
    deleteFileUploadInfo:function(id){
      this.$ajax.delete('BackgroundUpload/'+ id).then(function (res) {
        if (res.data.success) {
          _this.asynchronousList.findIndex((item,index) => {
            if(item.status !== 0 && item.id === id){
              _this.asynchronousList.splice(index,1);
              if(_this.messageCount > _this.asynchronousList.length){
                _this.messageCount = _this.asynchronousList.length;
                $('.file-transfer-content').animate({scrollTop:scrollTop - 15},20);
                _this.lastScrollTop = scrollTop -15;
              }
            }
          });
        }else if(res.data.message){
          _this.messageNotice('error', res.data.message);
        }        
      })
    },
    handleToBottom: function () {
      if (this.searchInfo.page < this.searchInfo.pageCount && !this.isLoading) {
        this.isLoading = true;
        this.searchInfo.page = this.searchInfo.page + 1;
        console.log(this.searchInfo.page);
        this.showAsynchronousInfo(false);
      }
    },
    /*下载批量上传的文件*/
    downloadImportFild:function(data){
      this.$ajax.get('Files/Get/'+ data.fileId,{responseType: 'blob',baseURL: window.g.FILE_ROOT}).then((res) => {
        const blob = res.data;
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          const a = document.createElement('a');
          a.download = data.fileName;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      })
    },


    batchItem:function(data,type){// 1.Edit Ac In Batch 2.Edit Dcs In Batch 3.Download
      let id = data.id;
      let users = [];
      data.details.filter(item => item.type == 0).forEach(it=>{
        if(it.extensions){
          users.push({name:it.extensions.userName,id:it.extensions.id})
        }
      })
      let userType = data.operationType;
      let pathName = '';
      switch (userType) {
        case 0:
          pathName = "Staff";
          break;
        case 1:
          pathName = "Visitor";
          break;
        case 2:
          pathName = "Vendor";
          break
        default:
          pathName = 'Tenant'
          break
       }
       let currentTime =  _this.common.formatDate( Date.now(),_this.$root.Time[_this.$root.Time.type].typeDate,1)
       let fileName = pathName + ' Template ' + currentTime + '.xlsx';
       if(type == 1 || type == 2){ 
        if(_this.$route.name == pathName){
          eventBus.$emit('userBatch', { users: users, type: type });
        }else{
          _this.$router.push({ name: pathName, params: { users: users, type: type } });
        }
        _this.failureDetailsModal = false;
        _this.isShow = false;
      }
      if(type == 3){
        this.$ajax.get('User/DownloadUserUploadTemplate/'+ id,{responseType: 'blob'}).then((res) => {
          const blob = res.data;
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (e) => {
            const a = document.createElement('a');
            a.download = fileName;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/navTop/asynchronousUpload.js